export const COEXISTENCE_NOTIFICATION_TEMPLATE_DRAFTS = [
  {
    type: "CASH_CLOSED",
    name: "coexistence_cash_closed",
    label: "Cierre de caja",
    bodyText: "Cierre de caja de {{1}}. Total del sistema: {{2}}. Total reportado: {{3}}. Diferencia: {{4}}. Apertura: {{5}}. Cierre: {{6}}. Responsable: {{7}}.",
    bodyExamples: ["Sede Centro", "$250.000", "$250.000", "$0", "08:00", "18:00", "Ana"],
  },
  {
    type: "AUDIT_SUMMARY",
    name: "coexistence_audit_summary",
    label: "Resumen de auditoría",
    bodyText: "Resumen de auditoría. Productos: eliminados {{1}}, editados {{2}}, creados {{3}}. Ingredientes: eliminados {{4}}, editados {{5}}, creados {{6}}. Transferencias: agregadas {{7}}, eliminadas {{8}}. Devoluciones: agregadas {{9}}, eliminadas {{10}}. Consulta el detalle en tu sistema.",
    bodyExamples: ["0", "1", "2", "0", "0", "0", "1", "0", "0", "0"],
  },
  {
    type: "STOCK_LOW",
    name: "coexistence_stock_low",
    label: "Inventario bajo · bodega",
    bodyText: "Alerta de inventario · {{1}}. Productos por debajo del mínimo: {{2}}. Ingredientes por debajo del mínimo: {{3}}.",
    bodyExamples: ["19 oct 2026", "3", "2"],
  },
  {
    type: "STOCK_LOW_STORE",
    name: "coexistence_stock_low_store",
    label: "Inventario bajo · sede",
    bodyText: "Alerta de inventario de {{1}} · {{2}}. Productos por debajo del mínimo: {{3}}. Ingredientes por debajo del mínimo: {{4}}.",
    bodyExamples: ["Sede Centro", "19 oct 2026", "3", "2"],
  },
  {
    type: "INVENTORY_REPORT",
    name: "coexistence_inventory_report",
    label: "Reporte de inventario",
    bodyText: "El reporte de inventario de {{1}} está disponible en el sistema.",
    bodyExamples: ["Sede Centro"],
  },
  {
    type: "DELAY_PAYMENT_ORDER",
    name: "coexistence_payment_reminder",
    label: "Pagos pendientes de confirmar",
    bodyText: "Tienes {{1}} de tienda con pago por transferencia pendiente de confirmar.",
    bodyExamples: ["2 órdenes"],
  },
] as const;
